var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"title":_vm.data.name}},[_vm._v(_vm._s(_vm.data.name))]),_c('span',{attrs:{"title":_vm.data.info}},[_vm._v(_vm._s(_vm.data.info))]),_c('meter',{attrs:{"optimum":"0","low":_vm.data.low,"high":_vm.data.high,"value":_vm.data.value}}),_c('span',{attrs:{"data-status":_vm.data.status}},[_vm._v(_vm._s(_vm.data.percent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }